import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { ApiContext } from '@shared/contexts';
import { toApiException } from '@shared/helpers/toApiException';
import { SignInContext } from '@modules/users';

import isAiBudgetRefusal from '../helpers/isAiBudgetRefusal.helper';

type TAiBudgetAvailabilityResponse = { available: true };

const useAiBudgetAvailability = (enabled: boolean) => {
  const { organization } = useContext(SignInContext);
  const { apiClient, retry, useHandleQueryError } = useContext(ApiContext);
  const query = useQuery<TAiBudgetAvailabilityResponse>({
    queryKey: ['ai-budget-availability', organization._id],
    queryFn: async () => (await apiClient.get<TAiBudgetAvailabilityResponse>('/ai/credits/availability')).data,
    enabled,
    retry,
  });
  const apiError = toApiException(query.error);
  const budgetRefusal = isAiBudgetRefusal(apiError) ? apiError : null;
  useHandleQueryError(query.isError && !budgetRefusal, query.error, 'Checking AI availability failed!', false);

  return { ...query, budgetRefusal };
};

export default useAiBudgetAvailability;
